import { render, staticRenderFns } from "./stap-3.vue?vue&type=template&id=2455cfeb&"
import script from "./stap-3.vue?vue&type=script&lang=js&"
export * from "./stap-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingRbcz: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Rbcz.vue').default,InschrijvingGeschillenorganisatie: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Geschillenorganisatie.vue').default,InschrijvingNavigation: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/navigation.vue').default})
